import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';

interface IERdvIdentificationWidgetProps {
    dictIdentificationQuestion1Label: string;
    dictIdentificationQuestion2Label: string;
    dictIdentificationQuestionTitle: string;
    dictIdentification101Label: string;
    dictIdentification103Label: string;
    dictIdentification104Label: string;
    dictYesLabel: string;
    dictNoLabel: string;
    lang: string;

    code: number;
    setCode: (key: number) => void;
    showValidateButton: (val: boolean) => void;
}

interface IERdvIdentificationWidgetState {
    question1: boolean | null;
    question2: boolean | null;
}

export class ERdvIdentificationWidget extends Component<
    IERdvIdentificationWidgetProps,
    IERdvIdentificationWidgetState
> {
    constructor(props: IERdvIdentificationWidgetProps) {
        super(props);

        if (+this.props.code !== 0) {
            const lastDigit = +this.props.code.toString().split('')[2];
            if (lastDigit === 1) {
                this.state = {
                    question1: false,
                    question2: null as any,
                };
                this.props.showValidateButton(true);
            } else if (lastDigit === 3) {
                this.state = {
                    question1: true,
                    question2: false,
                };
                this.props.showValidateButton(true);
            } else if (lastDigit === 4) {
                this.state = {
                    question1: true,
                    question2: true,
                };
                this.props.showValidateButton(true);
            }
        } else {
            this.state = {
                question1: null as any,
                question2: null as any,
            };
            this.props.showValidateButton(false);
        }
    }

    handleQuestion1 = (event: React.ChangeEvent<HTMLInputElement>) => {
        const val = event.target.value === 'true';
        this.setState(
            { question1: val, question2: null as any },
            this.generateCode
        );
        this.props.showValidateButton(!val);
    };

    handleQuestion2 = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.props.showValidateButton(true);
        this.setState(
            { question2: event.target.value === 'true' },
            this.generateCode
        );
    };

    generateCode = () => {
        const langCode = this.props.lang === 'fr' ? 100 : 200;
        if (!this.state.question1) {
            this.props.setCode(langCode + 1);
        } else {
            if (!this.state.question2) {
                this.props.setCode(langCode + 3);
            } else {
                this.props.setCode(langCode + 4);
            }
        }
    };

    render() {
        return (
            <div className="container">
                <fieldset className="umbraco-forms-fieldset">
                    <div className="row-fluid">
                        <div className="offset-md-2 col-md-8">
                            <div className="umbraco-forms-container">
                                <h2 className="h2">
                                    {this.props.dictIdentificationQuestionTitle}
                                </h2>
                                <div className="umbraco-forms-field singlechoice short-answer-radiobutton has-title active">
                                    <div className="label-wrapper">
                                        <label
                                            htmlFor="identification-question1"
                                            className="umbraco-forms-label"
                                        >
                                            {
                                                this.props
                                                    .dictIdentificationQuestion1Label
                                            }
                                        </label>
                                    </div>
                                    <div className="umbraco-forms-field-wrapper">
                                        <div
                                            className="radiobuttonlist"
                                            id="identification-question2"
                                        >
                                            <input
                                                type="radio"
                                                name="identification-question1"
                                                id="identification-question1-y"
                                                checked={
                                                    this.state.question1 ===
                                                    true
                                                }
                                                value="true"
                                                placeholder=""
                                                onChange={this.handleQuestion1}
                                            />
                                            <label htmlFor="identification-question1-y">
                                                {this.props.dictYesLabel}
                                            </label>
                                            <br />
                                            <input
                                                type="radio"
                                                name="identification-question1"
                                                id="identification-question1-n"
                                                checked={
                                                    this.state.question1 ===
                                                    false
                                                }
                                                value="false"
                                                placeholder=""
                                                onChange={this.handleQuestion1}
                                            />
                                            <label htmlFor="identification-question1-n">
                                                {this.props.dictNoLabel}
                                            </label>
                                            <br />
                                        </div>
                                    </div>
                                </div>
                                {!!this.state.question1 && (
                                    <div className="umbraco-forms-field singlechoice short-answer-radiobutton has-title active">
                                        <div className="label-wrapper">
                                            <label
                                                htmlFor="identification-question2"
                                                className="umbraco-forms-label"
                                            >
                                                {
                                                    this.props
                                                        .dictIdentificationQuestion2Label
                                                }
                                            </label>
                                        </div>
                                        <div className="umbraco-forms-field-wrapper">
                                            <div
                                                className="radiobuttonlist"
                                                id="identification-question2"
                                            >
                                                <input
                                                    type="radio"
                                                    name="identification-question2"
                                                    id="identification-question2-y"
                                                    checked={
                                                        this.state.question2 ===
                                                        true
                                                    }
                                                    value="true"
                                                    placeholder=""
                                                    onChange={
                                                        this.handleQuestion2
                                                    }
                                                />
                                                <label htmlFor="identification-question2-y">
                                                    {this.props.dictYesLabel}
                                                </label>
                                                <br />
                                                <input
                                                    type="radio"
                                                    name="identification-question2"
                                                    id="identification-question2-n"
                                                    checked={
                                                        this.state.question2 ===
                                                        false
                                                    }
                                                    value="false"
                                                    placeholder=""
                                                    onChange={
                                                        this.handleQuestion2
                                                    }
                                                />
                                                <label htmlFor="identification-question2-n">
                                                    {this.props.dictNoLabel}
                                                </label>
                                                <br />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        );
    }
}

WidgetHelper.register(ERdvIdentificationWidget, 'erdv-identification-widget');
